import React, { useEffect } from "react";
import track from "react-tracking";
import { useNavigate } from "react-router-dom";

import { useDialogBox } from "src/hooks/useDialogBox";

import { isUserLogin, handleLogin } from "src/utils/sessionUtils";

export const createNoAccessDialogRequest = (onClose) => [
	{
		title: "No Access",
		message: [
			"You don't have access to this page.",
			"Please contact the administrator if this is an error.  Thank you.",
		],
		type: "error",
	},
	null,
	onClose,
];

export const NoAccessPage = (props) => {
	const navigate = useNavigate();

	const { showDialog } = useDialogBox();

	useEffect(() => {
		if (isUserLogin()) {
			showDialog(...createNoAccessDialogRequest(() => navigate("/home")));
		} else {
			handleLogin();
		}
	}, [navigate, showDialog]);

	return null;
};

export const NoAccess = track(
	{ page: `${window.location.pathname}` },
	{ dispatchOnMount: (contextData) => ({ event: "No Access" }) },
)(NoAccessPage);
